import TripDetailsSubHeading from '../../tripDetailsSubHeading/TripDetailsSubHeading';
import CustomPrice from './CustomPrice';
import FixedAndVehiclePrice from './FixedAndVehiclePrice';
import GuidePrice from './guidePrice/GuidePrice';
import './price.css';

const Price = ({ data, datesType, group }) => {
    const type = window.location.pathname.split('/')[2];
    console.log(data);
    if (type === 'a' || type === 'g') {
        return <GuidePrice data={data.price} />;
    }

    return datesType === 'fixed' ? (
        <FixedAndVehiclePrice
            data={type === 't' || type === 'trip' ? data?.price : data}
            dateType={datesType}
            group={group}
        />
    ) : (
        <CustomPrice data={type === 't' || type === 'trip' ? data?.price : data} dateType={datesType} group={group} />
    );
};

export default Price;
